export const styles = {
  root: {
    margin: "1rem",
    borderRadius: "10px",
    width: "686px !important",
    height: "315px",
    border: "2px dashed",
    borderColor: "events.bluePrimary",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "events.blueShade2",
  },
  dropLabel: {
    marginTop: "16px",
    textAlign: "center",
  },
  button: {
    marginTop: "16px",
  },
  fileInput: {
    display: "none",
  },
};
